/* tslint:disable */
/* eslint-disable */
/**
 * AZOB
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Bundle object containing documents and recipients for signature process
 * @export
 * @interface Bundle
 */
export interface Bundle {
    /**
     * Process type (e.g., ONBOARDING_NUOVO_CLIENTE, AML, etc.)
     * @type {string}
     * @memberof Bundle
     */
    'processType'?: string;
    /**
     * Bundle name shown on eSaw
     * @type {string}
     * @memberof Bundle
     */
    'name'?: string;
    /**
     * Bundle source system or flow
     * @type {string}
     * @memberof Bundle
     */
    'source'?: string;
    /**
     * Bundle external id, used as reference key for caller systems
     * @type {string}
     * @memberof Bundle
     */
    'externalId'?: string;
    /**
     * Documents to sign
     * @type {Set<object>}
     * @memberof Bundle
     */
    'documents'?: Set<object>;
    /**
     * Recipients involved in sign process
     * @type {Set<object>}
     * @memberof Bundle
     */
    'recipients'?: Set<object>;
    /**
     * Signature type (e.g., FEQ)
     * @type {string}
     * @memberof Bundle
     */
    'signatureType'?: string;
    /**
     * Expiration date for bundle (timestamp)
     * @type {string}
     * @memberof Bundle
     */
    'expirationDate'?: string;
    /**
     * Events subscribed for callback url (e.g., CREATED, EXPIRED, SIGNED)
     * @type {Array<string>}
     * @memberof Bundle
     */
    'callbackEvents'?: Array<string>;
    /**
     * Callback url invoked for each event subscribed from the request
     * @type {string}
     * @memberof Bundle
     */
    'callbackUrl'?: string;
    /**
     * Redirect url executed after frontend signature action completed
     * @type {string}
     * @memberof Bundle
     */
    'redirectUrl'?: string;
    /**
     * Flag indicating if bundle should be archived
     * @type {boolean}
     * @memberof Bundle
     */
    'trustArchive'?: boolean;
}
/**
 * 
 * @export
 * @interface BundleStateResult
 */
export interface BundleStateResult {
    /**
     * 
     * @type {string}
     * @memberof BundleStateResult
     */
    'bundleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleStateResult
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleStateResult
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleStateResult
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleStateResult
     */
    'bundleStatus'?: BundleStateResultBundleStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BundleStateResult
     */
    'statusDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleStateResult
     */
    'signatureTypeCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleStateResult
     */
    'creationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BundleStateResult
     */
    'expirationDate'?: string;
    /**
     * 
     * @type {Array<RecipientState>}
     * @memberof BundleStateResult
     */
    'recipients'?: Array<RecipientState>;
    /**
     * 
     * @type {Array<DocumentState>}
     * @memberof BundleStateResult
     */
    'documents'?: Array<DocumentState>;
    /**
     * Process type code
     * @type {string}
     * @memberof BundleStateResult
     */
    'processTypeCode'?: string;
}

export const BundleStateResultBundleStatusEnum = {
    Created: 'CREATED',
    Signing: 'SIGNING',
    Signed: 'SIGNED',
    Rejected: 'REJECTED',
    Expired: 'EXPIRED',
    Retired: 'RETIRED'
} as const;

export type BundleStateResultBundleStatusEnum = typeof BundleStateResultBundleStatusEnum[keyof typeof BundleStateResultBundleStatusEnum];

/**
 * 
 * @export
 * @interface BundleStatus
 */
export interface BundleStatus {
    /**
     * Bundle identifier
     * @type {string}
     * @memberof BundleStatus
     */
    'bundleId'?: string;
    /**
     * Bundle status (CREATED, SIGNING, SIGNED, REJECTED, EXPIRED, RETIRED)
     * @type {string}
     * @memberof BundleStatus
     */
    'bundleStatus'?: string;
    /**
     * List of recipients with their statuses
     * @type {Array<RecipientStatus>}
     * @memberof BundleStatus
     */
    'recipients'?: Array<RecipientStatus>;
    /**
     * Whether bundle is ready for signing
     * @type {boolean}
     * @memberof BundleStatus
     */
    'ready'?: boolean;
    /**
     * Whether bundle has been signed
     * @type {boolean}
     * @memberof BundleStatus
     */
    'signed'?: boolean;
}
/**
 * Response containing bundle URL
 * @export
 * @interface BundleUrlResponse
 */
export interface BundleUrlResponse {
    /**
     * Response code (OK or KO)
     * @type {string}
     * @memberof BundleUrlResponse
     */
    'code'?: string;
    /**
     * Response message
     * @type {string}
     * @memberof BundleUrlResponse
     */
    'message'?: string;
    /**
     * 
     * @type {BundleUrlResponseResult}
     * @memberof BundleUrlResponse
     */
    'result'?: BundleUrlResponseResult;
}
/**
 * Result containing bundle URL
 * @export
 * @interface BundleUrlResponseResult
 */
export interface BundleUrlResponseResult {
    /**
     * Bundle URL
     * @type {string}
     * @memberof BundleUrlResponseResult
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface CreationOnboardingPfRequest
 */
export interface CreationOnboardingPfRequest {
    /**
     * 
     * @type {string}
     * @memberof CreationOnboardingPfRequest
     */
    'externalCustomerCode'?: string;
}
/**
 * 
 * @export
 * @interface CreationResponse
 */
export interface CreationResponse {
    /**
     * 
     * @type {string}
     * @memberof CreationResponse
     */
    'codiceCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreationResponse
     */
    'bundleId'?: string;
    /**
     * 
     * @type {Array<Document>}
     * @memberof CreationResponse
     */
    'documents'?: Array<Document>;
}
/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'documentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'documentCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'exludedFromBundle'?: boolean;
}
/**
 * Documents contained in bundle
 * @export
 * @interface DocumentState
 */
export interface DocumentState {
    /**
     * 
     * @type {string}
     * @memberof DocumentState
     */
    'documentCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentState
     */
    'documentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentState
     */
    'documentStatus'?: DocumentStateDocumentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentState
     */
    'statusDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentState
     */
    'toSign'?: boolean;
}

export const DocumentStateDocumentStatusEnum = {
    Created: 'CREATED',
    Archiving: 'ARCHIVING',
    Archived: 'ARCHIVED',
    SendingBo: 'SENDING_BO',
    SentBo: 'SENT_BO',
    Updated: 'UPDATED',
    UpdatedExpired: 'UPDATED_EXPIRED',
    Retired: 'RETIRED',
    Rejected: 'REJECTED',
    UpdatedRejected: 'UPDATED_REJECTED',
    UpdatedRetired: 'UPDATED_RETIRED'
} as const;

export type DocumentStateDocumentStatusEnum = typeof DocumentStateDocumentStatusEnum[keyof typeof DocumentStateDocumentStatusEnum];

/**
 * 
 * @export
 * @interface Documento
 */
export interface Documento {
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'nomeFile'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'numeroContratto'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'codiceTipoDocumento'?: DocumentoCodiceTipoDocumentoEnum;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'codiceTipoDocumentoCesam'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'contenuto'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'tipoServizio'?: DocumentoTipoServizioEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Documento
     */
    'flagEsaw'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Documento
     */
    'flagStrongdox'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'idEnvelopeNamirial'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'idDocumentoNamirial'?: string;
}

export const DocumentoCodiceTipoDocumentoEnum = {
    ModuloAperturaRapporti: 'MODULO_APERTURA_RAPPORTI',
    OpuscoloInformativo: 'OPUSCOLO_INFORMATIVO',
    RaccoltaDatiPep: 'RACCOLTA_DATI_PEP',
    SchedaFinanziaria: 'SCHEDA_FINANZIARIA',
    SchedaFinanziariaV2: 'SCHEDA_FINANZIARIA_V2',
    ContrattoMyAzimut: 'CONTRATTO_MY_AZIMUT',
    InformativaPrivacy: 'INFORMATIVA_PRIVACY',
    DocumentiFronteRetro: 'DOCUMENTI_FRONTE_RETRO',
    SpecimenFirma: 'SPECIMEN_FIRMA',
    AdeguataVerifica: 'ADEGUATA_VERIFICA',
    AdeguataVerificaPg: 'ADEGUATA_VERIFICA_PG',
    ModuloAperturaServizi: 'MODULO_APERTURA_SERVIZI',
    TabellaCostiMax: 'TABELLA_COSTI_MAX',
    LetteraRichiestaRiduzioneCommissionaleMax: 'LETTERA_RICHIESTA_RIDUZIONE_COMMISSIONALE_MAX',
    LetteraComunicazioneRiduzioneCommissionaleMax: 'LETTERA_COMUNICAZIONE_RIDUZIONE_COMMISSIONALE_MAX',
    TabellaCostiMaxFund: 'TABELLA_COSTI_MAX_FUND',
    LetteraRichiestaRiduzioneCommissionaleMaxFund: 'LETTERA_RICHIESTA_RIDUZIONE_COMMISSIONALE_MAX_FUND',
    LetteraComunicazioneRiduzioneCommissionaleMaxFund: 'LETTERA_COMUNICAZIONE_RIDUZIONE_COMMISSIONALE_MAX_FUND',
    ModuloRiduzioneCommissionaleRtoBpm: 'MODULO_RIDUZIONE_COMMISSIONALE_RTO_BPM',
    PrivacyAcceptanceMod: 'PRIVACY_ACCEPTANCE_MOD',
    RequestDoc: 'REQUEST_DOC',
    DocumentationDoc: 'DOCUMENTATION_DOC',
    RelationDoc: 'RELATION_DOC',
    AttorneyDoc: 'ATTORNEY_DOC',
    ModuloAperturaRapportiAfi: 'MODULO_APERTURA_RAPPORTI_AFI',
    ModuloAperturaRapportiPg: 'MODULO_APERTURA_RAPPORTI_PG',
    ModuloAperturaRapportiAfiPg: 'MODULO_APERTURA_RAPPORTI_AFI_PG',
    RaccoltaDatiPepPg: 'RACCOLTA_DATI_PEP_PG',
    SchedaTitolariEffettiviPg: 'SCHEDA_TITOLARI_EFFETTIVI_PG',
    SchedaFinanziariaPg: 'SCHEDA_FINANZIARIA_PG',
    SchedaFinanziariaLightPg: 'SCHEDA_FINANZIARIA_LIGHT_PG',
    SchedaFinanziariaPgpdV2: 'SCHEDA_FINANZIARIA_PGPD_V2',
    MaxUbsIndRichiestaAperturaContoEam: 'MAX_UBS_IND_RICHIESTA_APERTURA_CONTO_EAM',
    RtoUbsIndRichiestaAperturaContoEam: 'RTO_UBS_IND_RICHIESTA_APERTURA_CONTO_EAM',
    RtoUbsIndCluster2: 'RTO_UBS_IND_CLUSTER2',
    RtoUbsIndCluster3: 'RTO_UBS_IND_CLUSTER3',
    RtoUbsIndCluster4: 'RTO_UBS_IND_CLUSTER4',
    RtoUbsIndCluster5: 'RTO_UBS_IND_CLUSTER5',
    RtoUbsIndTrattamentoCommissionale: 'RTO_UBS_IND_TRATTAMENTO_COMMISSIONALE',
    RtoBpmIndFactaCrs: 'RTO_BPM_IND_FACTA_CRS',
    ModuloAperturaServizioCdl: 'MODULO_APERTURA_SERVIZIO_CDL',
    ModuloAperturaServizioPir: 'MODULO_APERTURA_SERVIZIO_PIR',
    ModuloAggiornamentoAml: 'MODULO_AGGIORNAMENTO_AML',
    ModuloAggiornamentoAmlPg: 'MODULO_AGGIORNAMENTO_AML_PG'
} as const;

export type DocumentoCodiceTipoDocumentoEnum = typeof DocumentoCodiceTipoDocumentoEnum[keyof typeof DocumentoCodiceTipoDocumentoEnum];
export const DocumentoTipoServizioEnum = {
    ConsulenzaBase: 'CONSULENZA_BASE',
    Max: 'MAX',
    MaxFund: 'MAX_FUND',
    RtoBpm: 'RTO_BPM',
    RtoUbs: 'RTO_UBS',
    ConsulenzaCollocamento: 'CONSULENZA_COLLOCAMENTO',
    Collocamento: 'COLLOCAMENTO',
    AdegVer: 'ADEG_VER',
    AdegVerPg: 'ADEG_VER_PG',
    RtoImi: 'RTO_IMI',
    ConsulenzaBasePersonaGiuridica: 'CONSULENZA_BASE_PERSONA_GIURIDICA',
    ContoDepositoLiquidita: 'CONTO_DEPOSITO_LIQUIDITA',
    DepositoPirAlternative: 'DEPOSITO_PIR_ALTERNATIVE',
    AggiornamentoAml: 'AGGIORNAMENTO_AML',
    MaxBnp: 'MAX_BNP',
    MaxFundBnp: 'MAX_FUND_BNP'
} as const;

export type DocumentoTipoServizioEnum = typeof DocumentoTipoServizioEnum[keyof typeof DocumentoTipoServizioEnum];

/**
 * 
 * @export
 * @interface DownloadGroupedRequest
 */
export interface DownloadGroupedRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DownloadGroupedRequest
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RecipientState
 */
export interface RecipientState {
    /**
     * 
     * @type {string}
     * @memberof RecipientState
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientState
     */
    'userType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientState
     */
    'roleTypeCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof RecipientState
     */
    'routingOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecipientState
     */
    'recipientStatus'?: RecipientStateRecipientStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RecipientState
     */
    'statusDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientState
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientState
     */
    'recipientFullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientState
     */
    'userBehalfOfId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientState
     */
    'userBehalfOfType'?: string;
}

export const RecipientStateRecipientStatusEnum = {
    ToNotify: 'TO_NOTIFY',
    NotifiedToSign: 'NOTIFIED_TO_SIGN',
    Signed: 'SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type RecipientStateRecipientStatusEnum = typeof RecipientStateRecipientStatusEnum[keyof typeof RecipientStateRecipientStatusEnum];

/**
 * 
 * @export
 * @interface RecipientStatus
 */
export interface RecipientStatus {
    /**
     * Recipient user identifier
     * @type {string}
     * @memberof RecipientStatus
     */
    'userId'?: string;
    /**
     * Recipient status (TO_NOTIFY, NOTIFIED_TO_SIGN, SIGNED, NOTIFIED_SIGNED, etc.)
     * @type {string}
     * @memberof RecipientStatus
     */
    'recipientStatus'?: RecipientStatusRecipientStatusEnum;
    /**
     * Recipient role type
     * @type {string}
     * @memberof RecipientStatus
     */
    'roleTypeCode'?: string;
    /**
     * Recipient user type
     * @type {string}
     * @memberof RecipientStatus
     */
    'userType'?: string;
}

export const RecipientStatusRecipientStatusEnum = {
    ToNotify: 'TO_NOTIFY',
    NotifiedToSign: 'NOTIFIED_TO_SIGN',
    Signed: 'SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type RecipientStatusRecipientStatusEnum = typeof RecipientStatusRecipientStatusEnum[keyof typeof RecipientStatusRecipientStatusEnum];

/**
 * Response containing bundle state information
 * @export
 * @interface ResponseBundleStateSchema
 */
export interface ResponseBundleStateSchema {
    /**
     * Response code
     * @type {string}
     * @memberof ResponseBundleStateSchema
     */
    'code'?: string;
    /**
     * Response message
     * @type {string}
     * @memberof ResponseBundleStateSchema
     */
    'message'?: string;
    /**
     * 
     * @type {BundleStateResult}
     * @memberof ResponseBundleStateSchema
     */
    'result'?: BundleStateResult;
}
/**
 * Response containing bundle code and transaction ID
 * @export
 * @interface ResponseResourceIdentifier
 */
export interface ResponseResourceIdentifier {
    /**
     * Response code (OK or KO)
     * @type {string}
     * @memberof ResponseResourceIdentifier
     */
    'code'?: string;
    /**
     * Response message
     * @type {string}
     * @memberof ResponseResourceIdentifier
     */
    'message'?: string;
    /**
     * 
     * @type {ResponseResourceIdentifierResult}
     * @memberof ResponseResourceIdentifier
     */
    'result'?: ResponseResourceIdentifierResult;
}
/**
 * Result containing bundle identifier
 * @export
 * @interface ResponseResourceIdentifierResult
 */
export interface ResponseResourceIdentifierResult {
    /**
     * Code of the bundle created
     * @type {string}
     * @memberof ResponseResourceIdentifierResult
     */
    'bundleCode'?: string;
    /**
     * Transaction id associated with the signature process flow started
     * @type {string}
     * @memberof ResponseResourceIdentifierResult
     */
    'transactionId'?: string;
}

/**
 * DocumentaleApi - axios parameter creator
 * @export
 */
export const DocumentaleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * genera documenti per aggiornamento aml
         * @param {string} idPratica 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiAML: async (idPratica: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPratica' is not null or undefined
            assertParamExists('creaDocumentiAML', 'idPratica', idPratica)
            const localVarPath = `/documentale/crea-documenti-aml/{idPratica}`
                .replace(`{${"idPratica"}}`, encodeURIComponent(String(idPratica)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * genera documenti per adeguata verifica
         * @param {string} idPratica 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiAV: async (idPratica: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPratica' is not null or undefined
            assertParamExists('creaDocumentiAV', 'idPratica', idPratica)
            const localVarPath = `/documentale/crea-documenti-av/{idPratica}`
                .replace(`{${"idPratica"}}`, encodeURIComponent(String(idPratica)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Onboarding persona fisica Do it yourself
         * @param {string} idPratica 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiInvestimento: async (idPratica: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPratica' is not null or undefined
            assertParamExists('creaDocumentiInvestimento', 'idPratica', idPratica)
            const localVarPath = `/documentale/crea-documenti-investimento/{idPratica}`
                .replace(`{${"idPratica"}}`, encodeURIComponent(String(idPratica)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Proxy endpoint to create a bundle in Zenith\'s SignRoom service
         * @param {string} customerCode The recipient userCode that wants to sign
         * @param {Bundle} bundle 
         * @param {boolean} [behalf] Flag indicating if the bundle is created on behalf of another user (typically false for PF, true for PG)
         * @param {string} [xFirebaseToken] Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBundle: async (customerCode: string, bundle: Bundle, behalf?: boolean, xFirebaseToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('createBundle', 'customerCode', customerCode)
            // verify required parameter 'bundle' is not null or undefined
            assertParamExists('createBundle', 'bundle', bundle)
            const localVarPath = `/documentale/bundle/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerCode !== undefined) {
                localVarQueryParameter['customerCode'] = customerCode;
            }

            if (behalf !== undefined) {
                localVarQueryParameter['behalf'] = behalf;
            }

            if (xFirebaseToken != null) {
                localVarHeaderParameter['X-Firebase-Token'] = String(xFirebaseToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bundle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download document
         * @param {string} fileId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument: async (fileId: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadDocument', 'fileId', fileId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('downloadDocument', 'userId', userId)
            const localVarPath = `/documentale/download/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download document by bundle
         * @param {DownloadGroupedRequest} downloadGroupedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentGrouped: async (downloadGroupedRequest: DownloadGroupedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadGroupedRequest' is not null or undefined
            assertParamExists('downloadDocumentGrouped', 'downloadGroupedRequest', downloadGroupedRequest)
            const localVarPath = `/documentale/download/grouped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadGroupedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve bundle state
         * @param {string} bundleId 
         * @param {string} authorization Authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundle: async (bundleId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bundleId' is not null or undefined
            assertParamExists('getBundle', 'bundleId', bundleId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getBundle', 'authorization', authorization)
            const localVarPath = `/documentale/bundle/{bundleId}`
                .replace(`{${"bundleId"}}`, encodeURIComponent(String(bundleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get bundle status
         * @param {string} bundleId 
         * @param {string} customerCode 
         * @param {string} [xFirebaseToken] Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundleStatus: async (bundleId: string, customerCode: string, xFirebaseToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bundleId' is not null or undefined
            assertParamExists('getBundleStatus', 'bundleId', bundleId)
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('getBundleStatus', 'customerCode', customerCode)
            const localVarPath = `/documentale/status/{bundleId}`
                .replace(`{${"bundleId"}}`, encodeURIComponent(String(bundleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerCode !== undefined) {
                localVarQueryParameter['customerCode'] = customerCode;
            }

            if (xFirebaseToken != null) {
                localVarHeaderParameter['X-Firebase-Token'] = String(xFirebaseToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Bundle Url
         * @param {string} bundleId 
         * @param {string} customerCode 
         * @param {string} [behalfOfCode] Optional code of the entity on whose behalf the customer is signing
         * @param {string} [xFirebaseToken] Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundleUrl: async (bundleId: string, customerCode: string, behalfOfCode?: string, xFirebaseToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bundleId' is not null or undefined
            assertParamExists('getBundleUrl', 'bundleId', bundleId)
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('getBundleUrl', 'customerCode', customerCode)
            const localVarPath = `/documentale/bundle/{bundleId}/url`
                .replace(`{${"bundleId"}}`, encodeURIComponent(String(bundleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerCode !== undefined) {
                localVarQueryParameter['customerCode'] = customerCode;
            }

            if (behalfOfCode !== undefined) {
                localVarQueryParameter['behalfOfCode'] = behalfOfCode;
            }

            if (xFirebaseToken != null) {
                localVarHeaderParameter['X-Firebase-Token'] = String(xFirebaseToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/documentale/public/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentaleApi - functional programming interface
 * @export
 */
export const DocumentaleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentaleApiAxiosParamCreator(configuration)
    return {
        /**
         * genera documenti per aggiornamento aml
         * @param {string} idPratica 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creaDocumentiAML(idPratica: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creaDocumentiAML(idPratica, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * genera documenti per adeguata verifica
         * @param {string} idPratica 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creaDocumentiAV(idPratica: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Documento>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creaDocumentiAV(idPratica, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Onboarding persona fisica Do it yourself
         * @param {string} idPratica 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creaDocumentiInvestimento(idPratica: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creaDocumentiInvestimento(idPratica, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Proxy endpoint to create a bundle in Zenith\'s SignRoom service
         * @param {string} customerCode The recipient userCode that wants to sign
         * @param {Bundle} bundle 
         * @param {boolean} [behalf] Flag indicating if the bundle is created on behalf of another user (typically false for PF, true for PG)
         * @param {string} [xFirebaseToken] Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBundle(customerCode: string, bundle: Bundle, behalf?: boolean, xFirebaseToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseResourceIdentifier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBundle(customerCode, bundle, behalf, xFirebaseToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download document
         * @param {string} fileId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocument(fileId: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocument(fileId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download document by bundle
         * @param {DownloadGroupedRequest} downloadGroupedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocumentGrouped(downloadGroupedRequest: DownloadGroupedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocumentGrouped(downloadGroupedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve bundle state
         * @param {string} bundleId 
         * @param {string} authorization Authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBundle(bundleId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseBundleStateSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBundle(bundleId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get bundle status
         * @param {string} bundleId 
         * @param {string} customerCode 
         * @param {string} [xFirebaseToken] Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBundleStatus(bundleId: string, customerCode: string, xFirebaseToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBundleStatus(bundleId, customerCode, xFirebaseToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Bundle Url
         * @param {string} bundleId 
         * @param {string} customerCode 
         * @param {string} [behalfOfCode] Optional code of the entity on whose behalf the customer is signing
         * @param {string} [xFirebaseToken] Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBundleUrl(bundleId: string, customerCode: string, behalfOfCode?: string, xFirebaseToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBundleUrl(bundleId, customerCode, behalfOfCode, xFirebaseToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentaleApi - factory interface
 * @export
 */
export const DocumentaleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentaleApiFp(configuration)
    return {
        /**
         * genera documenti per aggiornamento aml
         * @param {string} idPratica 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiAML(idPratica: string, options?: any): AxiosPromise<CreationResponse> {
            return localVarFp.creaDocumentiAML(idPratica, options).then((request) => request(axios, basePath));
        },
        /**
         * genera documenti per adeguata verifica
         * @param {string} idPratica 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiAV(idPratica: string, options?: any): AxiosPromise<Documento> {
            return localVarFp.creaDocumentiAV(idPratica, options).then((request) => request(axios, basePath));
        },
        /**
         * Onboarding persona fisica Do it yourself
         * @param {string} idPratica 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiInvestimento(idPratica: string, options?: any): AxiosPromise<CreationResponse> {
            return localVarFp.creaDocumentiInvestimento(idPratica, options).then((request) => request(axios, basePath));
        },
        /**
         * Proxy endpoint to create a bundle in Zenith\'s SignRoom service
         * @param {string} customerCode The recipient userCode that wants to sign
         * @param {Bundle} bundle 
         * @param {boolean} [behalf] Flag indicating if the bundle is created on behalf of another user (typically false for PF, true for PG)
         * @param {string} [xFirebaseToken] Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBundle(customerCode: string, bundle: Bundle, behalf?: boolean, xFirebaseToken?: string, options?: any): AxiosPromise<ResponseResourceIdentifier> {
            return localVarFp.createBundle(customerCode, bundle, behalf, xFirebaseToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Download document
         * @param {string} fileId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument(fileId: string, userId: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadDocument(fileId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download document by bundle
         * @param {DownloadGroupedRequest} downloadGroupedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentGrouped(downloadGroupedRequest: DownloadGroupedRequest, options?: any): AxiosPromise<File> {
            return localVarFp.downloadDocumentGrouped(downloadGroupedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve bundle state
         * @param {string} bundleId 
         * @param {string} authorization Authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundle(bundleId: string, authorization: string, options?: any): AxiosPromise<ResponseBundleStateSchema> {
            return localVarFp.getBundle(bundleId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get bundle status
         * @param {string} bundleId 
         * @param {string} customerCode 
         * @param {string} [xFirebaseToken] Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundleStatus(bundleId: string, customerCode: string, xFirebaseToken?: string, options?: any): AxiosPromise<BundleStatus> {
            return localVarFp.getBundleStatus(bundleId, customerCode, xFirebaseToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Bundle Url
         * @param {string} bundleId 
         * @param {string} customerCode 
         * @param {string} [behalfOfCode] Optional code of the entity on whose behalf the customer is signing
         * @param {string} [xFirebaseToken] Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundleUrl(bundleId: string, customerCode: string, behalfOfCode?: string, xFirebaseToken?: string, options?: any): AxiosPromise<BundleUrlResponse> {
            return localVarFp.getBundleUrl(bundleId, customerCode, behalfOfCode, xFirebaseToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(options?: any): AxiosPromise<void> {
            return localVarFp.getStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for creaDocumentiAML operation in DocumentaleApi.
 * @export
 * @interface DocumentaleApiCreaDocumentiAMLRequest
 */
export interface DocumentaleApiCreaDocumentiAMLRequest {
    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiCreaDocumentiAML
     */
    readonly idPratica: string
}

/**
 * Request parameters for creaDocumentiAV operation in DocumentaleApi.
 * @export
 * @interface DocumentaleApiCreaDocumentiAVRequest
 */
export interface DocumentaleApiCreaDocumentiAVRequest {
    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiCreaDocumentiAV
     */
    readonly idPratica: string
}

/**
 * Request parameters for creaDocumentiInvestimento operation in DocumentaleApi.
 * @export
 * @interface DocumentaleApiCreaDocumentiInvestimentoRequest
 */
export interface DocumentaleApiCreaDocumentiInvestimentoRequest {
    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiCreaDocumentiInvestimento
     */
    readonly idPratica: string
}

/**
 * Request parameters for createBundle operation in DocumentaleApi.
 * @export
 * @interface DocumentaleApiCreateBundleRequest
 */
export interface DocumentaleApiCreateBundleRequest {
    /**
     * The recipient userCode that wants to sign
     * @type {string}
     * @memberof DocumentaleApiCreateBundle
     */
    readonly customerCode: string

    /**
     * 
     * @type {Bundle}
     * @memberof DocumentaleApiCreateBundle
     */
    readonly bundle: Bundle

    /**
     * Flag indicating if the bundle is created on behalf of another user (typically false for PF, true for PG)
     * @type {boolean}
     * @memberof DocumentaleApiCreateBundle
     */
    readonly behalf?: boolean

    /**
     * Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
     * @type {string}
     * @memberof DocumentaleApiCreateBundle
     */
    readonly xFirebaseToken?: string
}

/**
 * Request parameters for downloadDocument operation in DocumentaleApi.
 * @export
 * @interface DocumentaleApiDownloadDocumentRequest
 */
export interface DocumentaleApiDownloadDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiDownloadDocument
     */
    readonly fileId: string

    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiDownloadDocument
     */
    readonly userId: string
}

/**
 * Request parameters for downloadDocumentGrouped operation in DocumentaleApi.
 * @export
 * @interface DocumentaleApiDownloadDocumentGroupedRequest
 */
export interface DocumentaleApiDownloadDocumentGroupedRequest {
    /**
     * 
     * @type {DownloadGroupedRequest}
     * @memberof DocumentaleApiDownloadDocumentGrouped
     */
    readonly downloadGroupedRequest: DownloadGroupedRequest
}

/**
 * Request parameters for getBundle operation in DocumentaleApi.
 * @export
 * @interface DocumentaleApiGetBundleRequest
 */
export interface DocumentaleApiGetBundleRequest {
    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiGetBundle
     */
    readonly bundleId: string

    /**
     * Authorization token
     * @type {string}
     * @memberof DocumentaleApiGetBundle
     */
    readonly authorization: string
}

/**
 * Request parameters for getBundleStatus operation in DocumentaleApi.
 * @export
 * @interface DocumentaleApiGetBundleStatusRequest
 */
export interface DocumentaleApiGetBundleStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiGetBundleStatus
     */
    readonly bundleId: string

    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiGetBundleStatus
     */
    readonly customerCode: string

    /**
     * Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
     * @type {string}
     * @memberof DocumentaleApiGetBundleStatus
     */
    readonly xFirebaseToken?: string
}

/**
 * Request parameters for getBundleUrl operation in DocumentaleApi.
 * @export
 * @interface DocumentaleApiGetBundleUrlRequest
 */
export interface DocumentaleApiGetBundleUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiGetBundleUrl
     */
    readonly bundleId: string

    /**
     * 
     * @type {string}
     * @memberof DocumentaleApiGetBundleUrl
     */
    readonly customerCode: string

    /**
     * Optional code of the entity on whose behalf the customer is signing
     * @type {string}
     * @memberof DocumentaleApiGetBundleUrl
     */
    readonly behalfOfCode?: string

    /**
     * Optional Firebase token for testing/debugging. If not provided, a token will be generated using the technical account.
     * @type {string}
     * @memberof DocumentaleApiGetBundleUrl
     */
    readonly xFirebaseToken?: string
}

/**
 * DocumentaleApi - object-oriented interface
 * @export
 * @class DocumentaleApi
 * @extends {BaseAPI}
 */
export class DocumentaleApi extends BaseAPI {
    /**
     * genera documenti per aggiornamento aml
     * @param {DocumentaleApiCreaDocumentiAMLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public creaDocumentiAML(requestParameters: DocumentaleApiCreaDocumentiAMLRequest, options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).creaDocumentiAML(requestParameters.idPratica, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * genera documenti per adeguata verifica
     * @param {DocumentaleApiCreaDocumentiAVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public creaDocumentiAV(requestParameters: DocumentaleApiCreaDocumentiAVRequest, options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).creaDocumentiAV(requestParameters.idPratica, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Onboarding persona fisica Do it yourself
     * @param {DocumentaleApiCreaDocumentiInvestimentoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public creaDocumentiInvestimento(requestParameters: DocumentaleApiCreaDocumentiInvestimentoRequest, options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).creaDocumentiInvestimento(requestParameters.idPratica, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Proxy endpoint to create a bundle in Zenith\'s SignRoom service
     * @param {DocumentaleApiCreateBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public createBundle(requestParameters: DocumentaleApiCreateBundleRequest, options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).createBundle(requestParameters.customerCode, requestParameters.bundle, requestParameters.behalf, requestParameters.xFirebaseToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download document
     * @param {DocumentaleApiDownloadDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public downloadDocument(requestParameters: DocumentaleApiDownloadDocumentRequest, options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).downloadDocument(requestParameters.fileId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download document by bundle
     * @param {DocumentaleApiDownloadDocumentGroupedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public downloadDocumentGrouped(requestParameters: DocumentaleApiDownloadDocumentGroupedRequest, options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).downloadDocumentGrouped(requestParameters.downloadGroupedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve bundle state
     * @param {DocumentaleApiGetBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public getBundle(requestParameters: DocumentaleApiGetBundleRequest, options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).getBundle(requestParameters.bundleId, requestParameters.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get bundle status
     * @param {DocumentaleApiGetBundleStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public getBundleStatus(requestParameters: DocumentaleApiGetBundleStatusRequest, options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).getBundleStatus(requestParameters.bundleId, requestParameters.customerCode, requestParameters.xFirebaseToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Bundle Url
     * @param {DocumentaleApiGetBundleUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public getBundleUrl(requestParameters: DocumentaleApiGetBundleUrlRequest, options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).getBundleUrl(requestParameters.bundleId, requestParameters.customerCode, requestParameters.behalfOfCode, requestParameters.xFirebaseToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentaleApi
     */
    public getStatus(options?: AxiosRequestConfig) {
        return DocumentaleApiFp(this.configuration).getStatus(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OnboardingApi - axios parameter creator
 * @export
 */
export const OnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Onboarding persona fisica Do it yourself
         * @param {string} idPratica 
         * @param {CreationOnboardingPfRequest} creationOnboardingPfRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiOnboardingDiy: async (idPratica: string, creationOnboardingPfRequest: CreationOnboardingPfRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPratica' is not null or undefined
            assertParamExists('creaDocumentiOnboardingDiy', 'idPratica', idPratica)
            // verify required parameter 'creationOnboardingPfRequest' is not null or undefined
            assertParamExists('creaDocumentiOnboardingDiy', 'creationOnboardingPfRequest', creationOnboardingPfRequest)
            const localVarPath = `/documentale/crea-documenti-onboarding-diy/{idPratica}`
                .replace(`{${"idPratica"}}`, encodeURIComponent(String(idPratica)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(creationOnboardingPfRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Onboarding persona fisica
         * @param {string} idPratica 
         * @param {CreationOnboardingPfRequest} creationOnboardingPfRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiOnboardingPf: async (idPratica: string, creationOnboardingPfRequest: CreationOnboardingPfRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPratica' is not null or undefined
            assertParamExists('creaDocumentiOnboardingPf', 'idPratica', idPratica)
            // verify required parameter 'creationOnboardingPfRequest' is not null or undefined
            assertParamExists('creaDocumentiOnboardingPf', 'creationOnboardingPfRequest', creationOnboardingPfRequest)
            const localVarPath = `/documentale/crea-documenti-onboarding-pf/{idPratica}`
                .replace(`{${"idPratica"}}`, encodeURIComponent(String(idPratica)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(creationOnboardingPfRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingApi - functional programming interface
 * @export
 */
export const OnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * Onboarding persona fisica Do it yourself
         * @param {string} idPratica 
         * @param {CreationOnboardingPfRequest} creationOnboardingPfRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creaDocumentiOnboardingDiy(idPratica: string, creationOnboardingPfRequest: CreationOnboardingPfRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creaDocumentiOnboardingDiy(idPratica, creationOnboardingPfRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Onboarding persona fisica
         * @param {string} idPratica 
         * @param {CreationOnboardingPfRequest} creationOnboardingPfRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creaDocumentiOnboardingPf(idPratica: string, creationOnboardingPfRequest: CreationOnboardingPfRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creaDocumentiOnboardingPf(idPratica, creationOnboardingPfRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OnboardingApi - factory interface
 * @export
 */
export const OnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingApiFp(configuration)
    return {
        /**
         * Onboarding persona fisica Do it yourself
         * @param {string} idPratica 
         * @param {CreationOnboardingPfRequest} creationOnboardingPfRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiOnboardingDiy(idPratica: string, creationOnboardingPfRequest: CreationOnboardingPfRequest, options?: any): AxiosPromise<CreationResponse> {
            return localVarFp.creaDocumentiOnboardingDiy(idPratica, creationOnboardingPfRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Onboarding persona fisica
         * @param {string} idPratica 
         * @param {CreationOnboardingPfRequest} creationOnboardingPfRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creaDocumentiOnboardingPf(idPratica: string, creationOnboardingPfRequest: CreationOnboardingPfRequest, options?: any): AxiosPromise<CreationResponse> {
            return localVarFp.creaDocumentiOnboardingPf(idPratica, creationOnboardingPfRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for creaDocumentiOnboardingDiy operation in OnboardingApi.
 * @export
 * @interface OnboardingApiCreaDocumentiOnboardingDiyRequest
 */
export interface OnboardingApiCreaDocumentiOnboardingDiyRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingApiCreaDocumentiOnboardingDiy
     */
    readonly idPratica: string

    /**
     * 
     * @type {CreationOnboardingPfRequest}
     * @memberof OnboardingApiCreaDocumentiOnboardingDiy
     */
    readonly creationOnboardingPfRequest: CreationOnboardingPfRequest
}

/**
 * Request parameters for creaDocumentiOnboardingPf operation in OnboardingApi.
 * @export
 * @interface OnboardingApiCreaDocumentiOnboardingPfRequest
 */
export interface OnboardingApiCreaDocumentiOnboardingPfRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingApiCreaDocumentiOnboardingPf
     */
    readonly idPratica: string

    /**
     * 
     * @type {CreationOnboardingPfRequest}
     * @memberof OnboardingApiCreaDocumentiOnboardingPf
     */
    readonly creationOnboardingPfRequest: CreationOnboardingPfRequest
}

/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
export class OnboardingApi extends BaseAPI {
    /**
     * Onboarding persona fisica Do it yourself
     * @param {OnboardingApiCreaDocumentiOnboardingDiyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public creaDocumentiOnboardingDiy(requestParameters: OnboardingApiCreaDocumentiOnboardingDiyRequest, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).creaDocumentiOnboardingDiy(requestParameters.idPratica, requestParameters.creationOnboardingPfRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Onboarding persona fisica
     * @param {OnboardingApiCreaDocumentiOnboardingPfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public creaDocumentiOnboardingPf(requestParameters: OnboardingApiCreaDocumentiOnboardingPfRequest, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).creaDocumentiOnboardingPf(requestParameters.idPratica, requestParameters.creationOnboardingPfRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


